export const PageStyleLoaderSymbol = Symbol('PageStyleLoader')
export const PageResourceFetcherSymbol = Symbol('PageResourceFetcher')
